import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FunctionAppService {
	readonly url: string = 'FunctionAppStatus';
	constructor(private http: HttpClient) {}

	public getAllInstances(): Observable<any> {
		return this.http.get<any>(this.url + '/getAllInstances');
	}

	public terminateSingleInstance(instanceId: string): Observable<any> {
		return this.http.get<any>(this.url + '/TerminateFunctionAppInstance/' + instanceId);
	}

	public purgeHistorySingleInstance(instanceId: string): Observable<any> {
		return this.http.get<any>(this.url + '/PurgeFunctionAppInstanceHistory/' + instanceId);
	}

	public getDurableFunctionInstanceData(): Observable<any> {
		return this.http.get<any>('FunctionApps' + '/GetDurableFunctionInstanceData/' );
	}

	public getDurableFunctionInstanceDataNew(functionAppId: number, instanceId: string): Observable<any> {
		return this.http.get<any>('FunctionApps' + '/PurgeFunctionAppInstanceHistory/' + functionAppId + '/' + instanceId);
	}

	public terminateSingleInstanceNew(functionAppId: number, instanceId: string): Observable<any> {
		return this.http.get<any>('FunctionApps' + '/TerminateFunctionAppInstance/' + functionAppId + '/' + instanceId);
	}
}
